import useGoals from '@/composables/goal/goals';
import { AND } from 'shared/api/query/filter';
import { COUNT, RESULT } from 'shared/api/query/constants';
import { GOAL_PARENT_QUERY_LEVEL } from '@/lib/constants';
import { applyBaseFilter } from '@/lib/filter/base-filter';
import { goalCascadeList } from '@/api/query/nebula/goal-cascade';
import { goalsById } from '@/api/query/nebula/goal';

export default function useGoalFetcher(
  viewParamsService,
) {
  const goalsSvc = useGoals();

  const getGoalsByIds = (
    ids,
    pagination = { page: 1, itemsPerPage: 20 },
  ) => goalsSvc.getGoals({
    queries: goalsById({
      ids,
      alias: RESULT,
      pagination: {
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        countAlias: COUNT,
      },
      order: viewParamsService.order.value,
      compareTo: viewParamsService.compareTo.value ? [viewParamsService.compareTo.value] : [],
      includeChildren: false,
      includeParents: false,
    }),
    countKey: 'childrenCount',
  });

  const getGoals = (
    filter = {
      searchTerm: '',
      selectedCycles: [],
      disabledGoalIds: [],
    },
    baseFilter = {},
    pagination = { page: 1, itemsPerPage: 20, countAlias: COUNT },
    options = {},
  ) => {
    // To make transition of parent alignment easier, we query full parent tree
    const parentLevels = GOAL_PARENT_QUERY_LEVEL;

    const childrenLevels = options.childrenLevels !== undefined ? options.childrenLevels : 1;

    return goalsSvc.getGoals({
      queries: applyBaseFilter({
        queries: goalCascadeList({
          pagination: {
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            countAlias: COUNT,
          },
          compareTo: viewParamsService.compareTo.value ? [viewParamsService.compareTo.value] : [],
          goalCycles: filter.selectedCycles,
          searchTerm: filter.searchTerm,
          filter: viewParamsService.gqlFilterObject.value.filterTree,
          varBlocks: viewParamsService.gqlFilterObject.value.varBlocks,
          excludedGoalIds: filter.disabledGoalIds,
          childrenPagination: { itemsPerPage: 30, page: 1 },
          order: viewParamsService.order.value,
          alias: RESULT,
          applyFilterOnFirstLevelOnly: viewParamsService.applyFilterOnFirstLevelOnly.value,
          childrenLevels,
          parentLevels,
        }),
        operator: AND,
        baseFilter,
      }),
      excludeLoaded: true,
    }).then((response) => ({
      entities: response[RESULT],
      count: response.count[0].count,
    }));
  };

  return {
    getGoalsByIds,
    getGoals,
  };
}
